<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <div class="ttshop_orderxq">
          <!-- 面包屑 -->
          <div class="ttshop_ordernav clearfloat">
            <p class="ttshop_navtext" @click="goTtshop_user">个人中心</p>
            <span>&gt;</span>
            <p class="ttshop_navtext" @click="goTtshop_usermyorder">订单中心</p>
            <span>&gt;</span>
            <p class="ttshop_orderdh">
              订单：<strong>{{ list.order_no }}</strong>
            </p>
          </div>
          <!-- 待支付订单 -->
          <div class="ttshop_orderdzf clearfloat">
            <div class="ttshop_orderdzfleft">
              <template v-if="list.type != 8">
                <h4 v-if="list.is_revoke == 1">已取消</h4>
                <template v-else-if="list.is_pay == 0">
                  <template v-if="list.pay_type == 2">
                    <h4 v-if="list.is_send == 0 && list.is_revoke == 0">
                      待发货
                    </h4>
                    <h4 v-if="list.is_send == 1 && list.is_confirm == 0">
                      待收货
                    </h4>
                    <h4 v-if="list.is_confirm == 1">已收货</h4>
                    <h4 v-if="list.is_comment == 0 && list.is_confirm == 1">
                      待评价
                    </h4>
                  </template>
                  <h4 v-else>待付款</h4>
                </template>
                <h4
                  v-if="
                    list.is_send == 0 && list.is_pay == 1 && list.is_revoke == 0
                  "
                >
                  待发货
                </h4>
                <h4 v-if="list.is_send == 1 && list.is_confirm == 0">待收货</h4>
                <h4 v-if="list.is_confirm == 1">已收货</h4>
                <h4 v-if="list.is_comment == 0 && list.is_confirm == 1">
                  待评价
                </h4>
              </template>
              <template v-else>
                <h4>{{ list.status }}</h4>
              </template>
              <template v-if="list.is_pay == 0">
                <template v-if="list.pay_type == 6">
                  <div class="d-flex align-items-center justify-content-center">
                    <template v-if="list.bank_receipt">
                      <!-- <p
                      v-if="list.is_pay == 0 && list.is_revoke == 0"
                      class="ttshop_orderlizf"
                    >
                      重新上传
                    </p> -->
                      <template v-if="list.is_pay == 0 && list.is_revoke == 0">
                        <el-upload
                          :on-change="
                            (file, fileList) => {
                              handleChange(file, fileList, list.order_id);
                            }
                          "
                          :show-file-list="false"
                          action="/api/default/upload-image"
                          accept="image/*"
                          :multiple="false"
                          :auto-upload="false"
                        >
                          <p class="again_upload">重新上传</p>
                        </el-upload>
                      </template>
                    </template>
                    <template v-else>
                      <!-- <p
                      v-if="list.is_pay == 0 && list.is_revoke == 0"
                      class="ttshop_orderlizf"
                    >
                      上传回执单
                    </p> -->
                      <template v-if="list.is_pay == 0 && list.is_revoke == 0">
                        <el-upload
                          :on-change="
                            (file, fileList) => {
                              handleChange(file, fileList, list.order_id);
                            }
                          "
                          :show-file-list="false"
                          action="/api/default/upload-image"
                          accept="image/*"
                          :limit="1"
                          :multiple="false"
                          :auto-upload="false"
                        >
                          <p class="again_upload">上传回执单</p>
                        </el-upload>
                      </template>
                    </template>
                    <p
                      v-if="list.bank_receipt"
                      class="examine_receipt"
                      @click="look_receipt"
                    >
                      查看回执单
                    </p>
                  </div>
                </template>
                <template v-else>
                  <template
                    v-if="
                      list.is_pay == 0 &&
                      list.pay_type != 2 &&
                      list.is_revoke == 0 &&
                      list.apply_delete != 1
                    "
                  >
                    <template v-if="list.type == 8">
                      <div v-if="list.ys_pay_status == 0">
                        <template
                          v-if="list.goods_list[0].pre_data.deposit_end"
                        >
                          <p
                            class="ttshop_orderlizf"
                            @click="pay_advance(list.order_id)"
                          >
                            支付定金
                          </p>
                        </template>
                      </div>
                      <div
                        v-else-if="list.ys_pay_status == 1"
                        style="text-align: center"
                      >
                        <template v-if="list.goods_list[0].pre_data.final_end">
                          <p
                            class="ttshop_orderlizf"
                            @click="pay_advance(list.order_id)"
                          >
                            支付尾款
                          </p>
                        </template>
                        <template v-else>
                          <span
                            style="
                              margin-bottom: 10px;
                              color: #ff0e25;
                              display: inline-block;
                            "
                            >{{ list.goods_list[0].pre_data.final_state }}</span
                          >
                        </template>
                      </div>
                    </template>
                    <template v-else>
                      <p
                        class="ttshop_orderlizf"
                        @click="payOrder(list.order_id, list.total_price)"
                      >
                        立即支付
                      </p>
                    </template>
                  </template>
                  <!-- <p
                    class="ttshop_orderlizf"
                    v-show="
                      list.is_pay == 0 &&
                      list.pay_type != 2 &&
                      list.is_revoke == 0
                    "
                    @click="payOrder(list.order_id, list.total_price)"
                  >
                    立即支付
                  </p> -->
                </template>
              </template>
              <template v-if="list.pay_type == 6 && list.bank_open.bank_image">
                <div class="ttshop_orderdzftext" @click="typical">查看示例</div>
              </template>
              <template v-if="list.is_send == 1 && list.is_confirm == 0">
                <div class="ttshop_orderdzftext" @click.stop="synchron">同步预留单</div>
              </template>
              <!-- <p class="ttshop_orderdzftext">修改订单</p> -->
              <template v-if="!list.is_pay && list.is_revoke == 0">
                <template v-if="list.type == 8">
                  <template v-if="list.goods_list[0].pre_data.is_refund != 0">
                    <template
                      v-if="
                        list.ys_pay_status == 1 &&
                        list.goods_list[0].pre_data.is_refund == 1
                      "
                    >
                      <p
                        class="ttshop_orderdzftext"
                        @click="orderRevoke(list.order_id)"
                      >
                        退定金
                      </p>
                    </template>
                    <template v-else>
                      <template
                        v-if="
                          list.ys_pay_status == 1 &&
                          list.goods_list[0].pre_data.is_refund == 1
                        "
                      >
                        <p
                          class="ttshop_orderdzftext"
                          @click="orderRevoke(list.order_id)"
                        >
                          退尾款
                        </p>
                      </template>
                      <template v-else>
                        <p
                          class="ttshop_orderdzftext"
                          @click="orderRevoke(list.order_id)"
                        >
                          取消订单
                        </p>
                      </template>
                    </template>
                  </template>
                  <template v-else>
                    <p
                      class="ttshop_orderdzftext"
                      @click="orderRevoke(list.order_id)"
                    >
                      取消订单
                    </p>
                  </template>
                </template>
                <template v-else>
                  <p
                    class="ttshop_orderdzftext"
                    @click="orderRevoke(list.order_id)"
                  >
                    取消订单
                  </p>
                </template>
              </template>
              <!-- <p
                class="ttshop_orderdzftext"
                v-show="
                  !list.is_pay && list.is_revoke == 0 && list.pay_type != 2
                "
                @click="orderRevoke(list.order_id)"
              >
                取消订单
              </p> -->
              <p
                class="ttshop_orderdzftext"
                v-show="
                  list.is_send == 1 &&
                  list.is_confirm == 1 &&
                  list.is_comment == 0
                "
                @click="goEvaluate(list.order_id)"
              >
                评价
              </p>
              <!-- <p class="ttshop_orderdzftext" v-show="list.is_pay && list.is_send==0 &&list.apply_delete!=1" @click="orderRevoke(list.order_id)">退款</p> -->
              <template
                v-if="
                  list.is_pay && list.is_send == 0 && list.apply_delete != 1
                "
              >
                <template v-if="list.type == 8">
                  <template v-if="list.goods_list[0].pre_data.is_refund != 0">
                    <p class="ttshop_orderdzftext" @click="turn_order(list)">
                      退款
                    </p>
                  </template>
                </template>
                <template v-else>
                  <p class="ttshop_orderdzftext" @click="turn_order(list)">
                    退款
                  </p>
                </template>
              </template>
              <!-- <p
                class="ttshop_orderdzftext"
                v-show="
                  list.is_pay && list.is_send == 0 && list.apply_delete != 1
                "
                @click="turn_order(list)"
              >
                退款
              </p> -->
              <!-- <p class="ttshop_orderdzftext" v-show="list.is_send == 1 && list.is_confirm == 1 && list.is_comment == 0" @click="goEvaluate(list.order_id)">评价</p> -->
              <p
                class="ttshop_orderdzftext"
                v-show="list.is_send == 1 && list.is_confirm == 0"
                @click="confirm(list.order_id)"
              >
                确认收货
              </p>
              <p
                class="ttshop_orderdzftext"
                v-show="
                  list.is_send == 0 &&
                  list.apply_delete == 1 &&
                  list.is_revoke == 0
                "
              >
                退款申请中
              </p>
              <p
                class="ttshop_orderdzftext"
                v-show="
                  list.is_send == 0 &&
                  list.apply_delete == 1 &&
                  list.is_revoke == 1
                "
              >
                退款成功
              </p>
            </div>
            <div class="ttshop_orderdzfright">
              <ul class="clearfloat">
                <li class="active">
                  <h5>1</h5>
                  <p>拍下商品</p>
                  <span></span>
                </li>
                <li
                  v-if="list.pay_type != 2"
                  :class="{ active: list.is_pay == 1 }"
                >
                  <h5>2</h5>
                  <p>付款</p>
                  <span></span>
                </li>
                <li :class="{ active: list.is_send == 1 }">
                  <h5>3</h5>
                  <p>卖家发货</p>
                  <span></span>
                </li>
                <li :class="{ active: list.is_confirm == 1 }">
                  <h5>4</h5>
                  <p>确认收货</p>
                  <span></span>
                </li>
                <li :class="{ active: list.is_comment == 1 }">
                  <h5>5</h5>
                  <p>评价</p>
                  <span></span>
                </li>
              </ul>
            </div>
          </div>
          <!-- 地址及物流信息 -->
          <div class="ttshop_orderdzwl clearfloat">
            <div class="ttshop_orderdzwleft">
              <h5>收货人信息</h5>
              <ul>
                <li class="clearfloat">
                  <p>收货人：</p>
                  <span>{{ list.name }}</span>
                </li>
                <li class="clearfloat">
                  <p>收货地址：</p>
                  <span>{{ list.address }}</span>
                </li>
                <li class="clearfloat">
                  <p>电话：</p>
                  <span>{{ list.mobile }}</span>
                </li>
              </ul>
            </div>
            <div class="ttshop_orderdzwlright">
              <!-- 暂无物流订单信息显示 -->
              <div class="ttshop_orderdzwlzw" v-if="!packagegood">
                <h5>暂无物流信息</h5>
              </div>
              <!-- <div class="ttshop_orderdzwlxinxi" v-else>
                <ul>
                  <li
                    class="clearfloat"
                    v-for="(item, index) in expressList"
                    :key="index"
                  >
                    <div class="ttshop_xinxitime">
                      {{ item.datetime }}
                    </div>
                    <i></i>
                    <div class="ttshop_jieduan">
                      <h5>{{ item.detail }}</h5>
                      <p>{{ item.memo }}</p>
                    </div>
                  </li>
                </ul>
              </div> -->
              <!-- 部分发货 -->
              <div class="shipment" v-else>
                <div class="parcel">
                  <div
                    class="parcel_li"
                    v-for="(item, index) in expressgood.express_data"
                    :key="index"
                    :class="[index == parcenum ? 'active' : '']"
                    @click="packagelist(index)"
                  >
                    包裹{{ index + 1 }}
                  </div>
                </div>
                <div class="logistics">
                  <div class="logistics_express">
                    <div class="logistics_express_img">
                      <img src="@/assets/images/express.png" alt="" />
                    </div>
                    <div class="logistics_express_title">
                      {{ packagegood.express }}
                    </div>
                    <div class="logistics_express_code">
                      物流单号 :{{ packagegood.express_no }}
                    </div>
                  </div>
                  <div class="logistics_good">
                    <div
                      class="logistics_good_data"
                      v-for="(item, index) in packagegood.goods_data"
                      :key="index"
                    >
                      <img :src="item.pic" alt="" />
                    </div>
                  </div>
                  <div class="ttshop_orderdzwlxinxi logistics_ttshop">
                    <ul>
                      <li
                        class="clearfloat"
                        v-for="(item, index) in express_detail"
                        :key="index"
                      >
                        <div class="ttshop_xinxitime">
                          {{ item.datetime }}
                        </div>
                        <i></i>
                        <div class="ttshop_jieduan">
                          <h5>{{ item.detail }}</h5>
                          <p>{{ item.memo }}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 订单信息 -->
          <div class="ttshop_ordernews">
            <h4>订单信息</h4>
            <ul class="clearfloat">
              <li class="clearfloat">
                <p>订单编号：</p>
                <span>{{ list.order_no }}</span>
              </li>
              <li class="clearfloat">
                <p>付款时间：</p>
                <span>{{ list.addtime }}</span>
              </li>
              <li class="clearfloat">
                <p>应支付金额：</p>
                <span>￥{{ list.pay_price }}</span>
              </li>
              <li class="clearfloat" v-if="list.pay_type == 1">
                <p>付款方式：</p>
                <span>在线支付</span>
              </li>
              <li class="clearfloat" v-if="list.pay_type == 2">
                <p>付款方式：</p>
                <span>货到付款</span>
              </li>
              <li class="clearfloat" v-if="list.pay_type == 6">
                <p>付款方式：</p>
                <span>线下转账</span>
              </li>
              <li class="clearfloat" v-if="list.pay_type == 3">
                <p>付款方式：</p>
                <span>余额支付</span>
              </li>
              <li class="clearfloat">
                <p>商品总额：</p>
                <span>￥{{ list.total_price }}</span>
              </li>

              <template v-if="list.bank_open">
                <li class="clearfloat" v-if="list.bank_open.bank_account">
                  <p>账户：</p>
                  <span>￥{{ list.bank_open.bank_account }}</span>
                </li>

                <li class="clearfloat" v-if="list.bank_open.bank_name">
                  <p>开户名称：</p>
                  <span>{{ list.bank_open.bank_name }}</span>
                </li>
                <li class="clearfloat" v-if="list.bank_open.bank_open">
                  <p>开户行：</p>
                  <span>{{ list.bank_open.bank_open }}</span>
                </li>
                <li class="clearfloat" v-if="list.bank_open.bank_number">
                  <p>联行号：</p>
                  <span>{{ list.bank_open.bank_number }}</span>
                </li>
              </template>
              <li class="clearfloat">
                <p>运费金额：</p>
                <span>￥{{ list.express_price }}</span>
              </li>
              <li class="clearfloat" v-if="list.discount  && list.discount < 10&&list.type!=8 ">
                <p>会员折扣：</p>
                <span>{{ list.discount }}折</span>
              </li>
              <li class="clearfloat" v-if="list.content ">
                <p>买家留言：</p>
                <span>{{ list.content }}</span>
              </li>
              <li class="clearfloat" v-if="list.ys_pay_status">
                <p>退款规则：</p>
                <span style="color: #ff4300">
                  <template v-if="list.goods_list[0].pre_data">
                    <template v-if="list.goods_list[0].pre_data.is_refund == 0">
                      该预售商品不支持退款
                    </template>
                  </template>
                </span>
              </li>
              <li class="clearfloat" v-if="list.wordss">
                <p>商家留言：</p>
                <span>￥{{ list.words }}</span>
              </li>
              <li class="clearfloat" v-if="list.spa_purchase_no">
                <p>SAP订单号：</p>
                <span>{{ list.spa_purchase_no }}</span>
              </li>
              <li class="clearfloat" v-if="list.spa_reserve_no">
                <p>预留订单号：</p>
                <span>{{ list.spa_reserve_no }}</span>
              </li>
              <li class="clearfloat" v-if="list.factory_id">
                <p>工厂：</p>
                <span>{{ list.factory_id }}</span>
              </li>
              <li class="clearfloat" v-if="list.cost_center_id">
                <p>成本中心：</p>
                <span>{{ list.cost_center_id }}</span>
              </li>
            </ul>
          </div>
          <!-- 商品信息 -->
          <div class="ttshop_shopnews">
            <div class="ttshop_shopnewstitle clearfloat">
              <p class="ttshop_shopfirst">商品信息</p>
              <p class="ttshop_shopbh">商品编号</p>
              <p class="ttshop_shopmoney">单价（元）</p>
              <p class="ttshop_shopnumber">数量</p>
              <p class="ttshop_shopcz">操作</p>
            </div>
            <div class="ttshop_shopconter">
              <div
                class="ttshop_shoplist clearfloat"
                v-for="(item, index) in list.goods_list"
                :key="index"
              >
                <div
                  class="ttshop_shoplistfirst clearfloat"
                  @click.stop="goods_detail(item.goods_id)"
                >
                  <div class="ttshop_orderimg">
                    <img class="img-default" :src="item.goods_pic" alt="" />
                  </div>
                  <div class="ttshop_ordertext">
                    <h5>{{ item.name }}</h5>
                    <span v-for="(attr, ids) in item.attr" :key="ids"
                      >{{ attr.attr_group_name }}:<strong>{{
                        attr.attr_name
                      }}</strong></span
                    >
                  </div>
                </div>
                <div class="ttshop_shopbhs">
                  <p>{{ item.goods_id }}</p>
                </div>
                <div class="ttshop_shopmoneys">
                  <p>￥{{ item.total_price }}</p>
                </div>
                <div class="ttshop_shopnumbers">
                  <p>{{ item.num }}</p>
                </div>
                <div class="ttshop_shopczs d-flex justify-content-center">
                  <template v-if="item.order_refund_enable == 1">
                    <p
                      class="ttshop_shopczsitem"
                      v-if="item.is_order_refund == 0"
                      @click.stop="goBarter(item)"
                    >
                      申请售后
                    </p>
                    <p v-if="item.is_order_refund == 1">已申请售后</p>
                  </template>
                </div>
              </div>
            </div>
            <div class="ttshop_shopbutton clearfloat">
              <div class="ttshop_shopbuttonright">
                <ul>
                  <li class="clearfloat">
                    <p>商品总额：</p>
                    <span>¥{{ list.total_price }}</span>
                  </li>
                  <li class="clearfloat">
                    <p style="word-spacing: 20px">运　　费：</p>
                    <span>¥{{ list.express_price }}</span>
                  </li>
                  <li class="clearfloat">
                    <p>应付总额：</p>
                    <strong>¥{{ list.pay_price }}</strong>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ttshop_pay">
      <el-dialog
        title=""
        :visible.sync="shopVisible"
        :before-close="payContTypeChange"
      >
        <div class="pay-title d-flex align-items-center justify-content-center">
          微信支付￥{{ payNum }}
        </div>
        <div
          class="pay-qrcode d-flex align-items-center justify-content-center"
        >
          <div id="qrcode" ref="qrcode"></div>
        </div>
      </el-dialog>
    </div>

    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
      <div v-if="list.bank_receipt" class="bill_monad">
        <img :src="list.bank_receipt" alt="" />
      </div>
    </el-dialog>
    <el-dialog :visible.sync="exampledialog" :before-close="exampclose">
      <div v-if="list.bank_open.bank_image" class="bill_monad">
        <img :src="list.bank_open.bank_image" alt="" />
      </div>
    </el-dialog>
    <!-- 预售的支付方式 -->
    <div class="ttshop_agreement" v-if="presell">
      <div class="ttshop_agreementbj" @click="pay_payment"></div>
      <div class="ttshop_agreementbox">
        <div class="ttshop_agreementitle clearfloat">
          <h5>支付方式</h5>
          <div class="close" @click="pay_payment"></div>
        </div>
        <div class="payment_head">
          <p class="payment_head_title">付款金额</p>
          <div class="payment_head_price">
            ￥
            <p v-if="list.pre_data">
              <template v-if="list.pre_data.ys_pay_status == 0">{{
                list.pre_data.dep_price
              }}</template>
              <template v-if="list.pre_data.ys_pay_status == 1">{{
                list.balance_cq_price
              }}</template>
            </p>
            <p v-else>{{ list.pay_price }}</p>
          </div>
        </div>
        <div class="payment_manner">
          <div
            class="manner_list clearfloat"
            v-for="(item, index) in ys_pay_type_list"
            :key="index"
            :data-index="index"
            @click="yscheckPayType"
            :class="{ active: item.payment == payment_ys_type }"
          >
            <div class="pay-img">
              <img class="img-default" :src="item.icon" alt />
            </div>
            <div class="pay-name">{{ item.name }}</div>
            <div class="pay-select" v-show="item.payment == payment_ys_type">
              <img
                class="img-default"
                src="../../assets/images/brand.png"
                alt
              />
            </div>
          </div>
        </div>

        <template v-if="list.pre_data && list.pre_data.ys_pay_status == 1">
          <div class="choice_sale" v-if="order_sale && order_sale.length">
            <div class="choice_title">选择优惠券</div>
            <div class="reduced" @click="choice_coupon">
              <div class="reduced_title" v-if="!select_sale">
                优惠券
                <span>({{ order_sale.length }})</span>
              </div>
              <div class="select_reduced">
                <div v-if="select_sale">-{{ select_sale.sub_price }}</div>
                <img src="../../assets/images/more_icon.png" />
              </div>
            </div>
          </div>
        </template>
        <div class="manner_foot">
          <button @click="affirm_pay()">确定</button>
        </div>
      </div>
    </div>
    <template v-if="concessions">
      <div class="ttshop_agreement">
        <div class="ttshop_agreementbj" @click="choice_coupon"></div>
        <div class="ttshop_agreementbox">
          <div class="ttshop_agreementitle clearfloat">
            <h5>选择优惠券</h5>
            <div class="close" @click="choice_coupon"></div>
          </div>
          <div class="concess_content">
            <div
              class="concess_li"
              v-for="(item, index) in order_sale"
              :key="index"
              :data-index="index"
              @click="select_concess"
            >
              <div class="coupon">
                <div class="coupon_left">
                  <div class="coupon_left_price">
                    ￥
                    <div>{{ item.sub_price }}</div>
                  </div>
                </div>
                <div class="title">
                  <div class="title-name">
                    {{ item.event_desc }}
                  </div>
                  <div class="title-condition">满{{ item.min_price }}使用</div>
                  <div class="title-time">
                    有效期至{{ item.begin_time }}-{{ item.end_time }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import QRCode from "qrcodejs2";
let Base64 = require("js-base64").Base64;
import "./user.css";
export default {
  components: {
    Header,
    Userheader,
    Foot,
  },
  data() {
    return {
      id: this.$route.query.id,
      list: {
        bank_open: {
          bank_image: "",
        },
      },
      time: "",
      shopVisible: false,
      payNum: "",
      expressList: "",
      expressgood: "",
      parcenum: 0,
      packagegood: "",
      express_detail: "",
      filephoto: "",
      dialogVisible: false,
      exampledialog: false,
      presell: false,
      advance_sale: "", //预售的商品内容
      ys_pay_type_list: [],
      pay_type_list: [],
      payment_type: "",
      user_info: "",
      order_sale: [], //支付尾款时的优惠券
      select_sale: "", //选择的优惠券
      concessions: false, //优惠券的弹窗
      payment_ys_type: -1,
    };
  },
  mounted() {
    this.orderDetail();
    this.expressDetail();
    this.partdata();
    let user_info = localStorage.getItem("userInfo");
    if (user_info) {
      this.user_info = user_info;
    }
  },
  methods: {
    goods_detail(goods_id) {
      this.$router.push({
        path: "/pages/goods/goods",
        query: {
          id: goods_id,
        },
      });
    },
    //订单详情
    goEvaluate(id) {
      this.$router.push({
        path: "/ttshop_evaluate",
        query: {
          id: id,
        },
      });
    },
    typical() {
      this.exampledialog = true;
    },
    exampclose() {
      this.exampledialog = false;
    },
    // 查看回执单
    look_receipt() {
      // let orderList = this.list;
      // this.receipt_detail = orderList[index];
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },

    async uploadImg(file, order_id) {
      let that = this;
      const formData = new FormData();
      // console.log(file.raw);
      formData.append("image", this.filephoto.raw);
      let config = {
        headers: {
          "Content-Type": "mutipart/form-data",
        },
      };
      let res = await this.$api.uploadImage(formData, config);
      console.log(res);
      if (res.code == 0) {
        console.log(res.data.url);
        that.receipt(res.data.url, order_id);
      } else {
        this.common.message(this, res);
      }
    },

    // 上传回执单
    receipt(url, order_id) {
      let that = this;
      this.$api
        .receipt({ order_id: order_id, pay_receipt: url })
        .then((res) => {
          if (res.code == 0) {
            that.$message({
              type: "success",
              message: '上传成功',
              showClose: true,
              offset: 200,
              duration: 1000,
            });
            that.orderDetail();
            that.expressDetail();
            that.partdata();
          } else {
            that.$message({
              type: "warning",
              message: res.msg,
              showClose: true,
              offset: 200,
              duration: 1000,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleChange(file, fileList, order_id) {
      this.filephoto = file;
      this.uploadImg(file, order_id);
      // console.log(file);
      // console.log(fileList);
      // console.log(order_id);
    },
    // 部分发货
    partdata() {
      var that = this;
      this.$api
        .shipment({
          order_id: this.id,
          type: "mall",
        })
        .then((res) => {
          if (res.code == 0) {
            that.expressgood = res.data;
            if (res.data.express_data.length && res.data.express_data) {
              that.packagegood = res.data.express_data[0];
              that.partexpress(res.data.express_data[that.parcenum].express_no);
            } else {
              that.packagegood = "";
              that.express_detail = "";
            }
          } else {
            that.expressgood = "";
            that.packagegood = "";
            that.express_detail = "";
          }
        })
        .catch((err) => {
          console.log(err);
          // this.user = err;
        });
    },
    packagelist(index) {
      this.parcenum = index;
      this.packagegood = this.expressgood.express_data[index];
      let express_no = this.expressgood.express_data[index].express_no;
      this.partexpress(express_no);
    },
    partexpress(express_no) {
      var that = this;
      this.$api
        .shipinfo({
          order_id: this.id,
          express_no: express_no,
          type: "mall",
        })
        .then((res) => {
          if (res.code == 0) {
            if (res.data.alibaba && res.data.alibaba == 1) {
              res.data.list = res.data.list.reverse();
            }
            that.express_detail = res.data.list;
          }
        });
    },
    //去个人中心
    goTtshop_user() {
      this.$router.replace("/ttshop_user");
    },
    //去列表
    goTtshop_usermyorder() {
      this.$router.replace("/ttshop_usermyorder");
    },
    //去退换货
    goBarter(item) {
      console.log(item);
      let id = item.order_detail_id;
      if (this.list.type == 3) {
        this.$router.push({
          path: "/pages/alibaba/orderRefund/orderRefund",
          query: {
            type: 1,
            order_detail_id: id,
            order_id: this.list.order_id,
            back_num: 1,
          },
        });
      } else {
        this.$router.replace({
          path: "/ttshop_barter",
          query: {
            id: id,
          },
        });
      }
    },
    //获取数据
    orderDetail() {
      var that = this;
      this.$api
        .orderDetail({
          order_id: this.id,
        })
        .then((res) => {
          console.log(res);
          let date = Number(Date.parse(new Date())) / 1000;
          if (res.data) {
            for (let i in res.data.goods_list) {
              if (res.data.goods_list[i].pre_data) {
                if (
                  Number(res.data.goods_list[i].pre_data.final_start_time) >
                  Number(date)
                ) {
                  res.data.goods_list[i].pre_data.final_cq_status = "未开始";
                } else if (
                  Number(res.data.goods_list[i].pre_data.final_start_time) <
                    Number(date) &&
                  Number(res.data.goods_list[i].pre_data.final_end_time) >
                    Number(date)
                ) {
                  if (res.data.ys_pay_status == 1) {
                    res.data.goods_list[i].pre_data.final_cq_status = "待付款";
                  } else {
                    res.data.goods_list[i].pre_data.final_cq_status = "已付款";
                  }
                } else if (
                  Number(res.data.goods_list[i].pre_data.final_end_time) <
                  Number(date)
                ) {
                  if (res.data.ys_pay_status != 1) {
                    res.data.goods_list[i].pre_data.final_cq_status = "已结束";
                  }
                }
                if (
                  Number(res.data.goods_list[i].pre_data.deposit_end_time) >
                  Number(date)
                ) {
                  res.data.goods_list[i].pre_data.deposit_end = true;
                } else {
                  res.data.goods_list[i].pre_data.deposit_end = false;
                }
                if (
                  Number(res.data.goods_list[i].pre_data.final_end_time) >
                    Number(date) &&
                  Number(res.data.goods_list[i].pre_data.final_start_time) <
                    Number(date)
                ) {
                  res.data.goods_list[i].pre_data.final_end = true;
                } else {
                  if (
                    Number(res.data.goods_list[i].pre_data.final_end_time) <
                    Number(date)
                  ) {
                    res.data.goods_list[i].pre_data.final_state =
                      "支付尾款时间已结束";
                  } else if (
                    Number(res.data.goods_list[i].pre_data.final_start_time) >
                    Number(date)
                  ) {
                    res.data.goods_list[i].pre_data.final_state =
                      "支付尾款时间还未开始";
                  }
                  res.data.goods_list[i].pre_data.final_end = false;
                }
                res.data.goods_list[i].pre_data.final_start_time = that.gettime(
                  res.data.goods_list[i].pre_data.final_start_time
                );
              }
            }
          }
          that.ys_pay_type_list = res.data.ys_pay_type_list;
          that.list = res.data;
        })
        .catch((err) => {
          console.log(err);
          // this.user = err;
        });
    },

    gettime(time) {
      var date = new Date(time * 1000);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      return y + "年" + m + "月" + d + "日 " + " " + h + ":" + minute;
    },
    // 物流信息
    expressDetail() {
      let that = this;
      this.$api
        .expressDetail({
          order_id: this.id,
          type: "mall",
        })
        .then((res) => {
          console.log(res);
          if (res.data.alibaba && res.data.alibaba == 1) {
            res.data.list = res.data.list.reverse();
          }
          that.expressList = res.data.list;
        })
        .catch((err) => {
          console.log(err);
          // this.user = err;
        });
    },
    // 确认收货
    confirm(order_id) {
      let that = this;
      this.$confirm("是否确认已收到货物？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.$api
            .confirm({
              order_id: order_id,
            })
            .then((res) => {
              that.$message({
                type: "success",
                message: res.msg,
                showClose: true,
                offset: 200,
                duration: 1000,
              });
              that.orderDetail();
            })
            .catch((err) => {
              // console.log(err);
              that.$message({
                type: "success",
                message: err.msg,
                showClose: true,
                offset: 200,
                duration: 1000,
              });
            });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
        });
    },
    //退款订单
    turn_order(item) {
      let id = item.order_id;
      let type = item.type;
      var that = this;
      if (type == 3) {
        this.$router.push({
          path: "/pages/alibaba/orderRefund/orderRefund",
          query: {
            type: 3,
            order_id: id,
            back_num: 1,
          },
        });
        return false;
      }

      let list = this.list;
      let message = "";
      if (list.goods_list[0].pre_data) {
        // 断点
        if (list.ys_pay_status == 1 || list.ys_pay_status == 2) {
          if (
            list.goods_list[0].pre_data.is_refund == 0 ||
            list.goods_list[0].pre_data.is_refund == 2
          ) {
            message = "该预售商品不支持退定金";
          }
        }
      }
      this.$confirm("是否退款该订单？" + message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.$api
            .orderRevoke({
              order_id: id,
            })
            .then((res) => {
              that.$message({
                type: "success",
                message: res.msg,
                showClose: true,
                offset: 200,
                duration: 1000,
              });
              that.orderDetail();
            })
            .catch((err) => {
              that.$message({
                type: "success",
                message: err.msg,
                showClose: true,
                offset: 200,
                duration: 1000,
              });
            });
        })
        .catch(() => {});
    },
    //取消订单
    orderRevoke(id) {
      let that = this;
      let list = this.list;
      let message = "";
      if (list.goods_list[0].pre_data) {
        // 断点
        if (list.ys_pay_status == 1 || list.ys_pay_status == 2) {
          if (
            list.goods_list[0].pre_data.is_refund == 0 ||
            list.goods_list[0].pre_data.is_refund == 2
          ) {
            message = "该预售商品不支持退定金";
          }
        }
      }
      this.$confirm("确定取消订单？" + message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api
            .orderRevoke({
              order_id: id,
            })
            .then((res) => {
              this.$message({
                type: "success",
                message: res.msg,
                showClose: true,
                offset: 200,
                duration: 1000,
              });
              this.orderDetail();
            })
            .catch((err) => {
              // console.log(err);
              this.$message({
                type: "success",
                message: err.msg,
                showClose: true,
                offset: 200,
                duration: 1000,
              });
            });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
        });
    },
    // 支付二维码关闭
    payContTypeChange() {
      let that = this;
      that
        .$confirm("是否取消支付", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
        .then(() => {
          that.shopVisible = false;
          clearInterval(this.time);
          this.orderDetail();
        })
        .catch(() => {
          console.log("取消");
        });
    },
    //支付
    payOrder(id, payNum) {
      let _this = this;
      this.payNum = payNum;
      _this.$api
        .orderPay({
          pay_type: "WECHAT_PAY",
          order_id: id,
        })
        .then((res) => {
          _this.shopVisible = true;
          // this.list = res.data
          _this.time = setInterval(() => {
            _this.orderStatus(res.res.order_no);
          }, 5000);
          let url = Base64.decode(res.res.code_url);
          setTimeout(function () {
            _this.qrcodeScan(url);
          }, 100);
        })
        .catch((err) => {
          // this.user = err;
        });
    },
    qrcodeScan(url) {
      this.$refs.qrcode.innerHTML = "";
      //生成二维码
      let qrcode = new QRCode("qrcode", {
        width: 150, // 二维码宽度
        height: 150, // 二维码高度
        text: url,
      });
    },
    //订单状态
    orderStatus(order) {
      if (this.shopVisible == false) {
        clearInterval(this.time);
      }
      this.$api
        .orderStatus({
          order_no: "order_" + order,
        })
        .then((res) => {
          if (res.code == 0) {
            clearInterval(this.time);
            this.$message({
              type: "success",
              message: res.msg,
              showClose: true,
              offset: 200,
              duration: 1000,
            });
            this.shopVisible = false;
            // this.$router.push("/ttshop_mybalance");
            this.orderDetail();
          }
        })
        .catch((err) => {});
    },
    // 预售
    pay_advance(order_id) {
      let order_list = this.list;
      if (order_list.goods_list[0].pre_data) {
        if (order_list.ys_pay_status == 1) {
          let balance = 0;
          balance =
            Number(order_list.goods_list[0].pre_data.fin_price) +
            Number(order_list.express_price);
          order_list.balance_cq_price = balance.toFixed(2);
          this.list = order_list;
          this.forwardsale(order_id);
          return false;
        }
      }
      this.presell = true;
    },
    forwardsale(order_id) {
      let that = this;
      let params = {
        order_id: order_id,
      };
      this.$api
        .forwardsale(params)
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.order_sale = res.data;
            that.presell = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    pay_payment() {
      this.presell = false;
      this.select_sale = "";
      this.payment_ys_type = -1;
    },
    yscheckPayType(e) {
      let that = this;
      let index = e.currentTarget.dataset.index;
      let data = that.ys_pay_type_list;
      if (data[index].payment == 3) {
        if (Number(this.user_info.money) < Number(this.list.pay_price)) {
          this.$message({
            type: "error",
            message: "余额不足",
            showClose: true,
            offset: 200,
            duration: 1000,
          });
          return false;
        }
      }
      for (let i in data) {
        data[i].checked = false;
      }
      data[index].checked = true;
      let pay_type = {
        pay_type: data[index].pay_type,
        payment: data[index].payment,
      };
      that.payment_ys_type = data[index].payment;
      that.ys_pay_type_list = data;
      that.payment_type = pay_type;
    },
    select_concess(e) {
      let index = e.currentTarget.dataset.index;
      let order_sale = this.order_sale;
      this.select_sale = order_sale[index];
      this.concessions = false;
      this.presell = true;
    },
    affirm_pay() {
      let that = this;
      if (this.payment_type == "") {
        this.$message({
          type: "error",
          message: "请选择支付方式",
          showClose: true,
          offset: 200,
          duration: 1000,
        });
        return false;
      }
      let advance_sale = this.list;
      if (advance_sale.goods_list[0].pre_data) {
        if (advance_sale.ys_pay_status == 1) {
          if (this.select_sale) {
            that.affirm_coupon();
          } else {
            that.confirm_pay();
          }
        } else if (advance_sale.ys_pay_status == 0) {
          that.confirm_pay();
        }
      }
    },
    // 确认使用优惠券
    affirm_coupon() {
      let that = this;
      let params = {
        order_id: this.list.order_id,
        user_coupon_id: this.select_sale.user_coupon_id,
      };
      this.$api.affirmsale(params).then((res) => {
        if (res.code == 0) {
          that.select_sale = "";
          that.confirm_pay();
        } else {
          that.$message({
            type: "error",
            message: res.msg,
            showClose: true,
            offset: 200,
            duration: 1000,
          });
        }
      });
    },
    // 支付预售商品
    confirm_pay() {
      let that = this;
      if (this.payment_type == "") {
        this.$message({
          type: "error",
          message: "请选择支付方式",
          showClose: true,
          offset: 200,
          duration: 1000,
        });
        return false;
      }
      let pay_type = this.payment_type.pay_type;
      let params = {
        pay_type: pay_type,
        order_id: this.list.order_id,
      };
      console.log(params);
      // return false;
      this.$api.orderPay(params).then((res) => {
        if (that.payment_type.payment == 4) {
          window.sessionStorage.setItem("alipay_type", true);
          const div = document.createElement("div");
          div.innerHTML = res.data;
          document.body.appendChild(div);
          document.forms[0].submit();
        } else if (that.payment_type.payment == 1) {
          that.shopVisible = true;
          that.time = setInterval(() => {
            that.orderStatus(res.res.order_no);
          }, 5000);
          let url = Base64.decode(res.res.code_url);
          setTimeout(function () {
            that.qrcodeScan(url);
          }, 100);
        } else {
          that.$message({
            showClose: true,
            message: "购买成功",
            type: "success",
            offset: 200,
            duration: 1000,
          });
          that.orderDetail();
        }
      });
    },
    choice_coupon() {
      this.concessions = !this.concessions;
      this.presell = !this.presell;
    },
    synchron() {
      let that = this;
      this.$confirm("确认是否要同步到预留单", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.ronization()
        })
        .catch(() => {
          
        });
    },
    ronization(item) {
      let that=this;
      let list=this.list
      let params = {
        order_id: list.order_id,
      };
      this.$api
        .synchronization(params)
        .then((res) => {
          if (res.code == 0) {
            that.$message({
              message: "同步成功",
              type: "success",
            });
          } else {
            that.$message({
              message: "" + res.msg,
              type: "warning",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.ttshop_orderxq {
  width: 100%;

  .ttshop_ordernav {
    width: 100%;
    margin-bottom: 20px;

    .ttshop_navtext {
      float: left;
      cursor: pointer;
      font-size: 12px;
      color: #333;
      transition: 0.5s;
      -moz-transition: 0.5s;
      -webkit-transition: 0.5s;
      -o-transition: 0.5s;

      &:hover {
        color: #ff0e25;
      }
    }

    span {
      float: left;
      font-size: 12px;
      color: #333;
      margin: 0 5px;
    }

    .ttshop_orderdh {
      float: left;
      font-size: 12px;
      color: #333;

      strong {
        font-size: 12px;
        color: #333;
        font-weight: 400;
      }
    }
  }

  .ttshop_orderdzf {
    width: 100%;
    height: 200px;
    background: #fff;
    margin-bottom: 20px;

    .ttshop_orderdzfleft {
      float: left;
      width: 290px;
      height: 200px;
      background: #ff9010;
      padding: 32px;
      box-sizing: border-box;

      h4 {
        font-size: 20px;
        color: #fff;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
        margin-bottom: 28px;
      }

      .ttshop_orderlizf {
        display: block;
        width: 72px;
        height: 24px;
        border-radius: 2px;
        background: #ffffff;
        text-align: center;
        line-height: 24px;
        font-size: 12px;
        color: #333;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;
        cursor: pointer;
        margin: 0 auto 20px;

        &:hover {
          background: #ff0e25;
          color: #fff;
        }
      }
      .examine_receipt{
         display: block;
        width: 72px;
        height: 24px;
        border-radius: 2px;
        background: #ffffff;
        text-align: center;
        line-height: 24px;
        font-size: 12px;
        color: #333;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;
        cursor: pointer;
        // margin: 0 auto 20px;
        margin-left: 20px;
        margin-bottom: 20px;

        &:hover {
          background: #ff0e25;
          color: #fff;
        }
      }

      .ttshop_orderdzftext {
        display: table;
        font-size: 12px;
        color: #fff;
        text-align: center;
        cursor: pointer;
        margin: 0 auto 8px;
      }
    }

    .ttshop_orderdzfright {
      float: left;
      width: 900px;
      height: 200px;
      background: #fff;
      padding: 80px 30px;
      box-sizing: border-box;

      ul {
        li {
          width: 20%;
          float: left;
          position: relative;

          h5 {
            display: block;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background: #ebebeb;
            text-align: center;
            line-height: 24px;
            font-size: 14px;
            color: #999;
            font-weight: 500;
            margin: 0 auto 13px;
            position: relative;
            z-index: 10;
          }

          p {
            font-size: 12px;
            color: #999;
            text-align: center;
            margin-bottom: 8px;
          }

          span {
            display: block;
            text-align: center;
            font-size: 12px;
            color: #999;
            height: 16px;
          }

          &.active::before {
            background: #ff9010;
          }

          &.active h5 {
            background: #ff9010;
            color: #fff;
          }

          &.active p {
            color: #ff9010;
          }

          &:first-child::before {
            width: 50%;
            left: 57%;
            top: 14%;
            transform: translateX(0%);
          }

          &:last-child::before {
            width: 50%;
            left: 0%;
            top: 14%;
            transform: translateX(0%);
          }

          &::before {
            content: "";
            position: absolute;
            top: 14%;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            height: 2px;
            background: #ebebeb;
          }
        }
      }
    }
  }

  .ttshop_orderdzwl {
    width: 100%;
    min-height: 274px;
    background: #fff;
    margin-bottom: 20px;

    .ttshop_orderdzwleft {
      float: left;
      width: 346px;
      min-height: 274px;
      padding: 24px 40px 24px 20px;
      box-sizing: border-box;
      position: relative;

      &::before {
        content: "";
        width: 1px;
        height: 226px;
        background: #ebebeb;
        position: absolute;
        top: 24px;
        right: -1px;
      }

      h5 {
        font-size: 16px;
        color: #999;
        font-weight: 500;
        line-height: 16px;
        margin-bottom: 30px;
      }

      ul {
        li {
          width: 100%;
          margin-bottom: 20px;

          &:last-child {
            margin-bottom: 0;
          }

          p {
            float: left;
            font-size: 12px;
            color: #666;
            width: 60px;
            text-align: right;
            margin-right: 16px;
            line-height: 18px;
          }

          span {
            float: left;
            max-width: 210px;
            font-size: 12px;
            color: #333;
            line-height: 18px;
          }
        }
      }
    }

    .ttshop_orderdzwlright {
      float: left;
      width: 843px;
      min-height: 274px;
      padding: 24px 35px;
      box-sizing: border-box;

      .ttshop_orderdzwlzw {
        width: 100%;
        padding-top: 90px;
        box-sizing: border-box;

        // display: none;
        h5 {
          font-size: 16px;
          color: #333;
          text-align: center;
          line-height: 16px;
          font-weight: 500;
          margin-bottom: 12px;
        }

        p {
          font-size: 12px;
          color: #999;
          text-align: center;
          line-height: 18px;
          font-weight: 400;
        }
      }

      .ttshop_orderdzwlxinxi {
        width: 100%;
        height: 225px;
        overflow-y: scroll;

        ul {
          li {
            width: 100%;

            .ttshop_xinxitime {
              float: left;
              width: 150px;
              font-size: 12px;
              color: #333;
              font-weight: 400;
              line-height: 12px;
              margin-right: 16px;
              padding-top: 4px;
              box-sizing: border-box;
              text-align: right;
            }

            i {
              float: left;
              display: block;
              width: 20px;
              height: 20px;
              background: #cccccc;
              border-radius: 50%;
              margin-right: 16px;
              position: relative;
              z-index: 10;
            }

            .ttshop_jieduan {
              float: left;
              max-width: 510px;
              padding-top: 4px;
              padding-bottom: 24px;
              box-sizing: border-box;
              position: relative;

              h5 {
                font-size: 12px;
                color: #999;
                font-weight: 500;
                line-height: 18px;
                margin-bottom: 8px;
              }

              p {
                font-size: 12px;
                color: #999;
                line-height: 18px;
                font-weight: 400;
              }

              &::before {
                content: "";
                width: 1px;
                height: 100%;
                background: #cccccc;
                position: absolute;
                top: 0;
                left: -26px;
              }
            }

            &:last-child .ttshop_jieduan:before {
              display: none;
            }
          }
        }
      }
    }
  }

  .ttshop_ordernews {
    width: 100%;
    margin-bottom: 20px;
    background: #fff;
    padding: 32px;
    box-sizing: border-box;

    h4 {
      font-size: 16px;
      color: #999;
      font-weight: 500;
      line-height: 16px;
      margin-bottom: 20px;
    }

    ul {
      li {
        float: left;
        width: 32%;
        margin-right: 2%;

        &:nth-child(3n) {
          margin-right: 0;
        }

        p {
          float: left;
          font-size: 12px;
          color: #666;
          font-weight: 400;
          line-height: 24px;
          text-align: right;
          width: 80px;
          margin-right: 10px;
        }

        span {
          float: left;
          font-size: 12px;
          color: #333;
          font-weight: 400;
          line-height: 24px;
        }
      }
    }
  }

  .ttshop_shopnews {
    width: 100%;

    .ttshop_shopnewstitle {
      width: 100%;
      height: 40px;
      background: #fafafa;
      line-height: 40px;

      p {
        float: left;
        height: 40px;
        font-size: 12px;
        color: #666;
        text-align: center;
      }

      .ttshop_shopfirst {
        width: 35%;
        padding-left: 24px;
        box-sizing: border-box;
        text-align: left;
      }

      .ttshop_shopbh {
        width: 20%;
      }

      .ttshop_shopmoney {
        width: 15%;
      }

      .ttshop_shopnumber {
        width: 15%;
      }

      .ttshop_shopcz {
        width: 15%;
      }
    }

    .ttshop_shopconter {
      width: 100%;

      .ttshop_shoplist {
        width: 100%;
        padding: 20px 0;
        box-sizing: border-box;
        background: #fff;
        border-bottom: 1px solid #ebebeb;

        .ttshop_shoplistfirst {
          float: left;
          width: 35%;
          padding-left: 24px;
          box-sizing: border-box;

          .ttshop_orderimg {
            float: left;
            width: 60px;
            height: 60px;
            margin-right: 12px;

            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .ttshop_ordertext {
            float: left;
            width: 295px;

            h5 {
              font-size: 12px;
              color: #333333;
              font-weight: 500;
              line-height: 18px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              margin-bottom: 5px;
            }

            span {
              font-size: 12px;
              color: #999;
              margin-right: 5px;

              strong {
                font-weight: 400;
                font-size: 12px;
                color: #999;
              }
            }
          }
        }

        .ttshop_shopbhs {
          float: left;
          width: 20%;
          padding: 0 10px;
          box-sizing: border-box;

          p {
            font-size: 12px;
            color: #666;
            text-align: center;
          }
        }

        .ttshop_shopmoneys {
          float: left;
          width: 15%;
          padding: 0 10px;
          box-sizing: border-box;

          p {
            font-size: 12px;
            color: #666;
            text-align: center;
          }
        }

        .ttshop_shopnumbers {
          float: left;
          width: 15%;
          padding: 0 10px;
          box-sizing: border-box;

          p {
            font-size: 12px;
            color: #666;
            text-align: center;
          }
        }

        .ttshop_shopczs {
          float: left;
          width: 15%;
          padding: 0 10px;
          box-sizing: border-box;

          .ttshop_shopczsitem {
            cursor: pointer;

            &:hover {
              color: #ff0e25;
            }
          }
        }
      }
      .ttshop_shoplist:hover {
        cursor: pointer;
      }
    }

    .ttshop_shopbutton {
      width: 100%;
      padding: 28px 60px 37px 60px;
      box-sizing: border-box;
      background: #fff;

      .ttshop_shopbuttonright {
        float: right;

        ul {
          li {
            p {
              float: left;
              width: 80px;
              text-align: right;
              font-size: 12px;
              color: #666;
              line-height: 32px;
            }

            span {
              font-size: 12px;
              color: #666;
              line-height: 32px;
            }

            strong {
              font-size: 18px;
              color: #ff4300;
              line-height: 32px;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}

.ttshop_pay {
  .pay-title {
    width: 100%;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .pay-qrcode {
    width: 200px;
    height: 200px;
  }
}

.ttshop_orderdzf {
  .ttshop_orderdzwleft {
    float: left;
    width: 800px;
    height: 200px;
    padding: 24px 40px 24px 20px;
    box-sizing: border-box;
    position: relative;

    h5 {
      font-size: 16px;
      color: #999;
      font-weight: 500;
      line-height: 16px;
      margin-bottom: 30px;
    }

    ul {
      li {
        width: 100%;
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }

        p {
          float: left;
          font-size: 12px;
          color: #666;
          width: 60px;
          text-align: right;
          margin-right: 16px;
          line-height: 18px;
        }

        span {
          float: left;
          max-width: 800px;
          font-size: 12px;
          color: #333;
          line-height: 18px;
        }
      }
    }
  }
}

.shipment {
  // padding-top: 12px;
  .parcel {
    width: 100%;
    // height: 40px;
    display: flex;
    align-items: center;
    border-bottom: solid 1px #e6e6e6;
    .parcel_li {
      display: inline-block;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: #999999;
      height: 40px;
      line-height: 40px;
    }
    .parcel_li.active {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #ff0e25;
      border-bottom: solid 1px #ff0e25;
    }
    .parcel_li:nth-child(n + 2) {
      margin-left: 20px;
    }
  }
  .logistics {
    margin-top: 12px;
    .logistics_express {
      display: flex;
      align-items: center;
      .logistics_express_img {
        width: 24px;
        height: 24px;
        background-color: #ff9010;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 12px;
          height: 12px;
        }
      }
      .logistics_express_title {
        margin-left: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 14px;
      }
      .logistics_express_code {
        margin-left: 16px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 14px;
      }
    }
    .logistics_good {
      margin-top: 14px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .logistics_good_data {
        width: 60px;
        height: 60px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .logistics_good_data:nth-child(n + 2) {
        margin-left: 10px;
      }
    }
    .logistics_ttshop {
      margin-top: 16px;
    }
  }
}

.monad_bill {
  display: flex;
  align-items: center;
  .monad_chong {
    margin-right: 10px !important;
  }
}
.bill_monad {
  width: 100%;
  height: auto;
  img {
    width: 100%;
    height: auto;
  }
}
.again_upload {
  display: block;
  width: 72px;
  height: 24px;
  border-radius: 2px;
  background: #ffffff;
  text-align: center;
  line-height: 24px;
  font-size: 12px;
  color: #333;
  transition: 0.5s;
  -moz-transition: 0.5s;
  -webkit-transition: 0.5s;
  -o-transition: 0.5s;
  cursor: pointer;
  margin: 0 auto 20px;

  &:hover {
    background: #ff0e25;
    color: #fff;
  }
}
::v-deep .el-upload.el-upload--text {
  width: 100%;
}
::v-deep .el-upload {
  width: 100%;
}

//预售的支付方式
.payment_head {
  padding: 20px 20px 10px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .payment_head_title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 16px;
  }
  .payment_head_price {
    display: flex;
    align-items: flex-end;
    margin-top: 10px;
    p {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
    }
  }
}
.payment_manner {
  width: 100%;
  padding: 10px 20px 10px 20px;
  box-sizing: border-box;
  .manner_list {
    position: relative;
    width: 80%;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #ebebeb;
    cursor: pointer;
    padding: 7px;
    box-sizing: border-box;
    margin: 0 auto 10px;

    &.active {
      border-color: #ff0e25;
    }

    .pay-img {
      float: left;
      width: 28px;
      height: 28px;
      border-radius: 2px;
      overflow: hidden;
    }

    .pay-name {
      float: left;
      padding-left: 12px;
      font-size: 14px;
      color: #333;
      line-height: 28px;
    }

    .pay-select {
      width: 12px;
      height: 12px;
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }
}
.manner_foot {
  width: 100%;
  height: 60px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  button {
    display: block;
    width: 180px;
    height: 40px;
    font-size: 14px;
    color: #fff;
    border-radius: 2px;
    outline: none;
    margin: 0 auto;
    border: 0;
    cursor: pointer;
    background: #ff0e25;
    transition: 0.5s;
    -moz-transition: 0.5s;
    -webkit-transition: 0.5s;
    -o-transition: 0.5s;

    &:hover {
      box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
    }
  }
}

.choice_sale {
  // margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
}
.choice_title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}
.reduced {
  // margin-top: 8px;
  // padding: 12px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.reduced_title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
}
.reduced_title span {
  margin-left: 5px;
}

.select_reduced {
  display: flex;
  align-items: center;
}
.select_reduced div {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 20px;
  margin-right: 8px;
}
.select_reduced img {
  width: 14px;
  height: 14px;
}
.concess_content {
  margin-top: 22px;
  max-height: 443px;
  overflow-y: scroll;
  .concess_li {
    margin: 10px 20px;
    height: 87px;
    background-image: url("../../assets/images/youhui.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .coupon {
      width: 100%;
      height: 87px;
      display: flex;
      align-items: center;
      .coupon_left {
        width: 94px;
        height: 87px;
        display: flex;
        justify-content: center;
        align-items: center;

        .coupon_left_price {
          display: flex;
          align-items: flex-end;
          font-size: 14px;
          font-family: Lato-Bold, Lato;
          font-weight: bold;
          color: #ff3000;
          line-height: 14px;
          div {
            font-size: 25px;
            font-family: Lato-Bold, Lato;
            font-weight: bold;
            color: #ff3000;
            line-height: 25px;
          }
        }
      }
      .title {
        margin-left: 16px;
        color: #ff0e25;
        .title-name {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ff0e25;
          line-height: 14px;
        }

        .title-time {
          margin-top: 12px;
          font-size: 11px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff0e25;
        }

        .title-condition {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff3000;
          line-height: 12px;
          margin-top: 6px;
        }
      }
    }
  }
}
// 支付方式
.ttshop_agreement {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;

  .ttshop_agreementbj {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  .ttshop_agreementbox {
    width: 400px;
    // height: 260px;
    background: #fff;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -200px;
    margin-top: -130px;
    border: 4px solid rgba(0, 0, 0, 0.4);
    border-radius: 4px;

    .ttshop_agreementitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: #f5f5f5;
      padding: 0 15px;
      box-sizing: border-box;

      h5 {
        float: left;
        font-size: 14px;
        color: #333;
        font-weight: bold;
      }

      .close {
        cursor: pointer;
        float: right;
        display: block;
        width: 20px;
        height: 20px;
        background: url(../../assets/images/ttshop_colse.png) center no-repeat;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;
        outline: none;
        margin-top: 10px;

        &:hover {
          background: url(../../assets/images/ttshop_colsed.png) center
            no-repeat;
        }
      }
    }
  }
}
</style>
